"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ArrowTrendDown: function() {
        return ArrowTrendDown;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ArrowTrendDown = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.29289 6.29289C1.68342 5.90237 2.31658 5.90237 2.70711 6.29289L9 12.5858L13.2929 8.29289C13.6834 7.90237 14.3166 7.90237 14.7071 8.29289L21 14.5858V10C21 9.44772 21.4477 9 22 9C22.5523 9 23 9.44772 23 10V17C23 17.5523 22.5523 18 22 18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16H19.5858L14 10.4142L9.70711 14.7071C9.31658 15.0976 8.68342 15.0976 8.29289 14.7071L1.29289 7.70711C0.902369 7.31658 0.902369 6.68342 1.29289 6.29289Z",
        fill: "currentColor"
    })
}), "ArrowTrendDown");
const _default = ArrowTrendDown;
